import httpClient from "@api/http";
import { CommunityData, PutCommunityData } from "@entity/community.entity";

class CommunityRepository {
  async getQnaList(): Promise<CommunityData[]> {
    const response = await httpClient.get("/community/all/admin/qna");
    return response.data;
  }

  async getCommunityList(): Promise<CommunityData[]> {
    const response = await httpClient.get("/community/all/admin/type");
    return response.data;
  }

  async createCommunity(data: PutCommunityData) {
    const response = await httpClient.post("/community/admin", {
      content: data.content,
      title: data.title,
      communityType: data.communityType,
    });

    return response.data;
  }

  async updateCommunityById(id: string, data: PutCommunityData) {
    const response = await httpClient.put(`/community/admin/${id}`, {
      content: data.content,
      title: data.title,
      communityType: data.communityType,
    });

    return response.data;
  }

  async deleteById(id: string) {
    return await httpClient.delete(`/community/admin/${id}`);
  }

  async getPresignedUrl(id: string, fileName: string) {
    const response = await httpClient.post(`/community/${id}/presigned-url`, {
      fileName,
    });
    return response.data;
  }

  async createPicture(id: string, keys: string[]) {
    const response = await httpClient.post(`/community/${id}/picture`, {
      keys,
    });
    return response.data;
  }

  async deletePicture(id: string, pictureId: string) {
    const response = await httpClient.delete(`/community/${id}/picture/${pictureId}`);
    return response.data;
  }
}

export default new CommunityRepository();
